/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const coreComponentsTeachingBubbleMessages = defineMessages({
    sidebarCollapseTitle: {
        id: 'core.coreComponentsTeachingBubbleMessages.sidebarCollapseTitle',
        defaultMessage: 'You’ve collapsed the menu'
    },
    sidebarCollapseBody: {
        id: 'core.coreComponentsTeachingBubbleMessages.sidebarCollapseBody',
        defaultMessage: 'You’ve collapsed the menu to get more room. You can expand it again here'
    }
});
